import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';

/* Helpers */
import getCurrencyPreference from '../utils/getCurrencyPreference';

/* Actions */
import { setAndShowCurrency } from '../actions/currencyMobileActions';

class SharedCurrencyLoader extends React.Component {
    componentWillReceiveProps(nextProps) {
        const prevProps = this.props;
        const { regionalInfo } = nextProps.viewer;
        const { user } = nextProps;
        const forcedCurrency = nextProps.forcedCurrency;

        const newCurrency = getCurrencyPreference({
            user,
            regionalInfo,
            forcedCurrency,
        });

        if (prevProps.currency !== newCurrency || !prevProps.showCurrency) {
            // we are not currency displaying the correct currency.
            // Update in redux and re-render
            prevProps.setAndShowCurrency({ currency: newCurrency });
        }
    }

    render() {
        return null;
    }
}

SharedCurrencyLoader.propTypes = {
    forcedCurrency: PropTypes.string,
    showCurrency: PropTypes.bool.isRequired,
    setAndShowCurrency: PropTypes.func.isRequired,
    viewer: PropTypes.object.isRequired,
    user: PropTypes.object,
};

SharedCurrencyLoader.contextTypes = {
    relay: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const { currencyReducer: { currency, showCurrency } } = state;
    return {
        showCurrency,
        currency,
    };
}

SharedCurrencyLoader = connect(mapStateToProps, { setAndShowCurrency })(SharedCurrencyLoader);

export default createFragmentContainer(SharedCurrencyLoader, {
    viewer: graphql`
        fragment SharedCurrencyLoader_viewer on Viewer {
            regionalInfo @include(if: $isClient) @skip(if: $fetchUser) {
                currency
            }
        }
    `,
    user: graphql`
        fragment SharedCurrencyLoader_user on User {
            isVerifiedTrade
            profile {
                currency
            }
        }
    `,
});
